import { all } from "redux-saga/effects";
import authSaga from "../sagas/authSaga";
import usersSaga from "./usersSaga";
import productsSaga from "./productsSaga";
import batchesSaga from "./batchesSaga";
import { dashboardSaga } from "./dashboardSaga";
import prodsealsSaga from "./prodsealsSaga";
import scanHistorySaga from "./scanHistorySaga";
import organizationSaga from "./organizationSaga";
import customersSaga from "./customerSaga";
import brandsSaga from "./brandsSaga";
import impersonationSaga from "./impersonationSaga";

export default function* rootSaga() {
  yield all([
    authSaga(),
    usersSaga(),
    productsSaga(),
    batchesSaga(),
    dashboardSaga(),
    prodsealsSaga(),
    scanHistorySaga(),
    organizationSaga(),
    customersSaga(),
    brandsSaga(),
    impersonationSaga(),
  ]);
}
